<template>
<v-flex>
    <v-layout row class="content-header">
        <v-flex md7 class="content-title">
            <h2>Certificados</h2>
            <h4>Consulte e faça download de certificados.</h4>
        </v-flex>
        <v-flex md4>
            <v-text-field
            v-model="termoPesquisa"
            label="Pesquisa"
            placeholder="CPF do Segurado"
            v-mask="CPFMask" 
            outlined
            class="input-pesquisa"
            @keyup.enter="pesquisar()"
            ></v-text-field>
        </v-flex>
        <v-flex md1>
            &nbsp;<v-btn color="info" @click="pesquisar()"><v-icon>mdi-magnify</v-icon></v-btn>
        </v-flex>
        <v-flex md12>
            <div class="line"></div>
        </v-flex>
    </v-layout>
    <v-layout row class="content-body overflow-y-auto">
        <v-flex md12>
            <v-data-table
                :headers="headers"
                :items="certificados"
                :items-per-page="topItems"
                :loading="loading"
                loading-text="Carregando... Por favor aguarde."
                :no-data-text="noDataText"
                no-results-text="Nenhuma informação encontrada"
                :sort-by="['DataInicioVigencia']"
                :sort-desc="[true]"                          
                class="">
                <template v-slot:item.CpfSegurado="{ item }">
                    {{ formatarCpfCnpj(item.CpfSegurado) }}
                </template>
                <template v-slot:item.dataInicioVigencia="{ item }">
                    {{ FormatarData(item.dataInicioVigencia) }}
                </template>
                <template v-slot:item.dataFimVigencia="{ item }">
                    {{ FormatarData(item.dataFimVigencia) }}
                </template>                
                <template v-slot:item.anexo="{ item }">
                    <img class="hover" src="/img/icon-pdf.png" @click="gerarCertificado(item)" />
                </template>
            </v-data-table>

        <v-overlay :value="fullLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        </v-flex>
    </v-layout>
</v-flex>
</template>

<script>

    import Vue from "vue";
    import { mapState, mapGetters } from 'vuex';
    import { mask } from 'vue-the-mask';
    import Helpers from "@/utilities/Helpers";

    export default {
        mixins: [Helpers],
        directives: {
        mask,
        },          
        data() {
            return {
                baseURL: Vue.prototype.$httpPortal.defaults.baseURL,
                termoPesquisa: "",
                loading: false,
                fullLoading: false,
                topItems: 10,
                headers: [
                    {text: "Certificado", value: "NumeroCertificado", sortable: true},
                    {text: "Estipulante", value: "NomeEstipulante", sortable: true},
                    {text: "Segurado", value: "NomeSegurado", sortable: true},
                    {text: "CPF", value: "CpfSegurado", sortable: true},
                    {text: "Cod. Segurado", value: "CodigoSegurado", sortable: true},
                    {text: "Início de Vigência (24h)", value: "DataInicioVigencia", sortable: true},
                    {text: "Fim de Vigência  (24h)", value: "DataFimVigencia", sortable: true},
                    {text: "Download", value: "anexo", sortable: false}
                ],
                certificados: [],
                noDataText : "Nenhuma informação pesquisada",
                CPFMask: '###.###.###-##',
            }
        },        
        methods: {
            pesquisar(){
                let codigoCorretor = this.usuario.codCorretor;
                let cpf = this.termoPesquisa;
                console.log(cpf);
                cpf = cpf.split('.').join('').replace('-', '');
                console.log(cpf);
                if (cpf.length > 10)
                {
                    this.loading = true;
                    this.fullLoading = true;                    
                    //let url = "CertificadoOds/BuscarPorCpf/" + codigoCorretor + "/" + cpf;
                    //let url = "ResumoSeguradoCorretor/" + codigoCorretor + "/" + cpf;
                    let url = "CertificadoOds/" + codigoCorretor + "/" + cpf;

                    // Request apolices
                    Vue.prototype.$httpPortal.get(url)
                    .then(res => {
                        console.log(res.data);
                        this.certificados = res.data;
                        if(res.data.length == 0)
                        {
                            this.noDataText = "Nenhuma informação encontrada";
                        }                    
                        this.loading = false;
                        this.fullLoading = false;
                    })
                    .catch(ex => {
                        console.log(ex);
                        this.noDataText = "Nenhuma informação encontrada";
                        this.loading = false;
                        this.fullLoading = false;
                    })    
                } else {
                    this.showToast("warning","Atenção!","É necessário digitar um CPF");
                }
            },
            gerarCertificado(item){
                //this.fullLoading = true;
                let url = this.baseURL + "Emissao/Certificado/" + item.NumeroCertificado + "/"+ item.NumeroApolice + "/"+ item.CodigoSegurado + "/"+ item.CodigoEmpresa;
                if(item.EnderecoArquivo != null)
                {
                    url = item.EnderecoArquivo;
                }
                window.open(url, "_blank");                
            }
        },
        computed: {
        ...mapGetters("usuarioModule", { usuario: "getUserInfo" })
        },
    }
</script>
